export default __webpack_public_path__ + "static/benefit-2-a4c69b99aed2c96b085ed2dec6229cbe.jpg";